<div class="confirmation-dialog overflow-unset">
	<div class="dialog-header">
		<h2 mat-dialog-title class="dialog-title">
			<mat-icon *ngIf="data.icon" [class]="'dialog-icon ' + (data.iconColor || '')">
				{{ data.icon }}
			</mat-icon>
			{{ data.title }}
		</h2>
	</div>

	<mat-dialog-content class="dialog-content overflow-unset">
		<p class="dialog-message" [innerHTML]="data.message"></p>

		<div class="col-12 p-0 m-0" *ngIf="reasonTypeList">
			<div class="col-4 p-0 m-0 mt-3 mb-3">
				<label class="font-normal mb-2">Select Reason:</label>
				<p-dropdown [options]="reasonTypeList" placeholder="Select Reason"
							optionLabel="name"
							[(ngModel)]="selectReasonType"
							(ngModelChange)="onReasonChange($event)">
				</p-dropdown>
			</div>
		</div>
		<div class="col-12 p-0" *ngIf="selectReasonType?.name === 'Other'">
			<div class="font-normal mb-2">Custom Reason</div>
			<textarea rows="5" cols="30"
					  placeholder="Please provide the reason for this action..."
					  pInputTextarea [autoResize]="true"
					  [(ngModel)]="reasonText"
					  (ngModelChange)="onReasonTextChange($event)"
					  maxlength="255"></textarea>
		</div>
	</mat-dialog-content>

	<mat-dialog-actions class="dialog-actions" align="end">
		<button *ngFor="let button of data.buttons; let i = index"
				mat-raised-button
				[color]="button.color"
				[class]="button.class"
				[class.highlight-shake]="highlightCancel && i === 0"
				(click)="onButtonClick(button.result)"
				[disabled]="button.result === true && isConfirmDisabled"
				cdkFocusInitial>
			{{ button.label }}
		</button>
	</mat-dialog-actions>
</div>

